import { WinePackageWidgetModel } from '../../../models/WinePackageWidgetModel';

/**
 * The WinePackageTitle component renders the title of a wine package.
 * @param winePackage - The object containing information about the wine package.
 * @returns The WinePackageTitle component is returning JSX elements.
 */

export const WinePackageTitle = ({ winePackage }: { winePackage: WinePackageWidgetModel }) => {
  return <h1 className='font-body h-[23px] text-black font-semibold min-[350px]:text-[16px] md:text-[18px] truncate'>{winePackage.title}</h1>;
};
